import FilterOutlined from '@icons/FilterOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';
import FilterPopover from './FilterPopover';

const FilterButton = () => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      setAnchor(e.currentTarget);
    },
    [setAnchor]
  );
  const onClose = useCallback(() => {
    setAnchor(null);
  }, [setAnchor]);
  return (
    <>
      <Tooltip title="Filters">
        <IconButton color={!!anchor ? 'primary' : 'default'} onClick={onClick}>
          <FilterOutlined />
        </IconButton>
      </Tooltip>
      <FilterPopover anchor={anchor} onClose={onClose} />
    </>
  );
};
export default FilterButton;
